import { useEffect, useCallback, useState, useMemo } from 'react'
import { useWindowContext, Tabs, noop } from '@iqueue/ui-kit'
import DroppableStatusCard from '../../components/DroppableStatusCard'
import './translations'
import useTranslate, { t } from '../../hooks/useTranslate'

export default function OptionPage() {
  const { setTitle, togglePaddings } = useWindowContext()
  const [activeTab, setActiveTab] = useState(1)
  const locale = useTranslate()
  const translatedTitle = useMemo(() => t('optionPage.title'), [locale])

  const tabsConfig = useMemo(() => {
    return [
      { id: 1, title: t('optionPage.tabs.statusBoard') },
    ]
  },[t, locale])

  const renderTabContent = useCallback((id) => {
    switch (id) {
      case 1:
        return <DroppableStatusCard/>
      default:
        return <div>Неизвестная вкладка</div>
    }
  }, [])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
  }, [translatedTitle])

  return <div className="settings-tabs">
    <Tabs
      entries={ tabsConfig }
      current={ activeTab }
      render={(item) => {
        return {
          id: item.id,
          title: item.title,
        }
      }}
      onTabChanged={ (id) => setActiveTab(id) }
    />

    <div className="tab-content">
      { renderTabContent(activeTab) }
    </div>
  </div>
}
